<template>
	<div class="layout-topbar" v-if="loggedIn">
		<router-link to="/" class="layout-topbar-logo">
			<span>Harborwall</span>
		</router-link>
		<!--
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
			<i class="pi pi-bars"></i>
		</button>
		-->
		<!--
		<button class="p-link layout-topbar-menu-button layout-topbar-button">
			<i class="pi pi-ellipsis-v"></i>
		</button>
		-->
		<ul class="layout-topbar-menu hidden lg:flex origin-top" v-if="loggedIn">
			<!--
			<li>
				<router-link to="/search">
					<button class="p-link layout-topbar-button" v-tooltip.bottom="'Search'">
						<i class="pi pi-search"></i>
						<span>Search</span>
					</button>
				</router-link>
			</li>
			-->
			<li>
				<router-link to="/domains">
					<button class="p-link layout-topbar-button" v-tooltip.bottom="'Domains'">
						<i class="pi pi-box"></i>
						<span>Domains</span>
					</button>
				</router-link>
			</li>
			<li>
				<router-link to="/instances">
					<button class="p-link layout-topbar-button" v-tooltip.bottom="'Instances'">
						<i class="pi pi-cloud"></i>
						<span>Instances</span>
					</button>
				</router-link>
			</li>
			<!--
			<li>
				<button class="p-link layout-topbar-button" v-tooltip.bottom="'Notifications'">
					<i class="pi pi-bell"></i>
					<span>Notifications</span>
				</button>
			</li>
			-->
			<li>
				<Menu id="overlay_menu" ref="menu" :model="items" :popup="true" />
				<button class="p-link layout-topbar-button" @click="toggle" aria-haspopup="true" aria-controls="overlay_menu" v-tooltip.bottom="'Account'">
					<i class="pi pi-user"></i>
					<span>Account</span>
				</button>
			</li>
		</ul>
		<ul class="layout-topbar-menu hidden lg:flex origin-top" v-if="!loggedIn">
			<li>
				<router-link to="/login">
					<button class="p-link layout-topbar-button" v-tooltip.bottom="'Login'">
						<i class="pi pi-user"></i>
						<span>Login</span>
					</button>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	data() {
        return {
            items: []
    	}
    },
    methods: {
    	async logout () {
      		await this.$store.dispatch('auth/logout')
      		this.$router.push('/login')
    	},
    	toggle(event) {
            this.$refs.menu.toggle(event);
        },
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
        },
		//onTopbarMenuToggle(event) {
        //    this.$emit('topbar-menu-toggle', event);
        //},
    },
    computed: {
    	loggedIn() {
      		return this.$store.state.auth.status.loggedIn;
    	},
    	user() {
    		return this.$store.state.auth.user
    	}
    },
    watch: {
    	user(newVal) {
    		if (newVal) {
	    		var menu_items = []

	    		menu_items.push({
	                        label: 'Notifications',
	                        icon: 'pi pi-bell',
	                        to: '/notifications'
	                    })
	    		menu_items.push({
	                        label: 'Settings',
	                        icon: 'pi pi-cog',
	                        to: '/account'
	                    })

	    		menu_items.push({
	    					label: 'sep',
	      	  				separator: true
	    				})

	    		if (this.$store.state.auth.user.is_superadmin) {
					menu_items.push({
	                        label: 'Admin',
	                        icon: 'pi pi-bolt',
	                        to: '/admin'
	                    })

		    		menu_items.push({
		    					label: 'sep',
		      	  				separator: true
		    				})    			
	    		}

	    		menu_items.push({
	                        label: 'Logout',
	                        icon: 'pi pi-power-off',
	                        command: this.logout
	                    })

    			this.items = [{
            	        label: this.$store.state.auth.user.name,
            	        items: menu_items,
            	    }]

	    	}
	    	else {
	    		this.items = []
	    	}
    	}
    },
    mounted: function () {
    	if (this.$store.state.auth.status.loggedIn) {
    		var menu_items = []

    		menu_items.push({
                        label: 'Notifications',
                        icon: 'pi pi-bell',
                        to: '/notifications'
                    })
    		menu_items.push({
                        label: 'Settings',
                        icon: 'pi pi-cog',
                        to: '/account'
                    })

    		menu_items.push({
    					label: 'sep',
      	  				separator: true
    				})

    		if (this.$store.state.auth.user.is_superadmin) {
				menu_items.push({
                        label: 'Admin',
                        icon: 'pi pi-bolt',
                        to: '/admin'
                    })

	    		menu_items.push({
	    					label: 'sep',
	      	  				separator: true
	    				})    			
    		}

    		menu_items.push({
                        label: 'Logout',
                        icon: 'pi pi-power-off',
                        command: this.logout
                    })



    		this.items = [{
                    label: this.$store.state.auth.user.name,
                    items: menu_items,
                }]
    	}
    	else {
    		this.items = []
    	}

    	
    }
}
</script>

<style lang="scss" scoped>
  .router-link-active {
    i {
        color: var(--blue-500);
    }
}
</style>